import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Header } from "./Schools";
import { ROLE_LABELS, normalizeRole } from "@/lib/rbac";
import { User, Lock, ArrowRight, Mail } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  const roleLabel = ROLE_LABELS[normalizeRole(user?.role || "")] || user?.role;

  return (
    <div className="fade-up">
      <Header title="Settings" subtitle="Workspace and account preferences." />

      <div className="mt-6 grid gap-4 max-w-xl">
        {/* Profile card */}
        <Link to="/admin/profile"
          className="rounded-2xl border border-gray-200 bg-white p-5 flex items-center gap-4 hover:border-gray-300 hover:shadow-sm transition-all group">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-400 to-violet-500 grid place-items-center text-white font-bold shrink-0">
            {(user?.name || "?")[0].toUpperCase()}
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-medium text-[#0F172A]">{user?.name}</div>
            <div className="text-sm text-gray-500 truncate">{user?.email}</div>
            <span className="text-xs text-[#4F46E5]">{roleLabel}</span>
          </div>
          <ArrowRight className="w-4 h-4 text-gray-400 group-hover:text-[#4F46E5] transition-colors shrink-0" />
        </Link>

        {/* Quick links */}
        <div className="rounded-2xl border border-gray-200 bg-white divide-y divide-gray-100">
          <Link to="/admin/profile"
            className="flex items-center gap-3 px-5 py-4 hover:bg-gray-50 transition-colors group">
            <User className="w-4 h-4 text-gray-400 group-hover:text-[#4F46E5] shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-[#0F172A]">Edit Profile</div>
              <div className="text-xs text-gray-500">Update your name and mobile number</div>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-[#4F46E5] transition-colors" />
          </Link>
          <Link to="/admin/profile"
            className="flex items-center gap-3 px-5 py-4 hover:bg-gray-50 transition-colors group">
            <Lock className="w-4 h-4 text-gray-400 group-hover:text-[#4F46E5] shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-[#0F172A]">Change Password</div>
              <div className="text-xs text-gray-500">Update your account password</div>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-[#4F46E5] transition-colors" />
          </Link>
          <Link to="/admin/email-integration"
            className="flex items-center gap-3 px-5 py-4 hover:bg-gray-50 transition-colors group">
            <Mail className="w-4 h-4 text-gray-400 group-hover:text-[#4F46E5] shrink-0" />
            <div className="flex-1">
              <div className="text-sm font-medium text-[#0F172A]">Email Integration</div>
              <div className="text-xs text-gray-500">Configure Gmail or Hostinger SMTP for outbound emails</div>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-300 group-hover:text-[#4F46E5] transition-colors" />
          </Link>
        </div>

        {/* System info */}
        <div className="rounded-2xl border border-gray-200 bg-white p-5 text-xs text-gray-500 grid gap-1.5">
          <div className="font-medium text-gray-700 text-sm mb-1">System</div>
          <p>Configure SMTP email delivery under <Link to="/admin/email-integration" className="text-indigo-600 underline">Email Integration</Link>. Supports Gmail and Hostinger.</p>
          <p>All uploaded files are served from <span className="font-mono bg-gray-100 px-1 rounded">/api/uploads/</span>.</p>
        </div>
      </div>
    </div>
  );
}
